<template>
  <div>
    <div class="d-flex justify-space-between mb-5">
      <div>
        <div class="page-title mb-2">Requirement Form</div>
        <div class="d-flex align-center">
          <Iconify
              icon="bxs:message-square-detail"
              color="var(--theme-color-seven)"
              class="mr-3"
          ></Iconify>
          แบบฟอร์มความต้องการเทคโนโลยีที่ส่งยื่น
        </div>
      </div>

      <div class="d-flex flex-column gap-12">
        <div class="d-flex gap-12">
          <div class="flex-center gap-8" style="max-width: 250px" 
            v-if="!this.isOIC"
          >
            <div class="min-width-max">สถานะ</div>
            <SelectBox 
                placeholder="สถานะ"
                hide-details
                clearable
                :items="statusMaster" 
                @onChange="searchData.status = $event; getAllForms()"
            ></SelectBox>
          </div>

          <div style="max-width: 250px">
            <TextField
                hide-details
                placeholder="ค้นหา"
                append-inner-icon="search"
                @onChange="searchData.keyword = $event"
                @onEnter="getAllForms()"
            ></TextField>
          </div>
        </div>
        <div class="d-flex justify-end" v-if="!this.isOIC">
          <Button @onClick="createForm"> สร้างแบบฟอร์ม</Button>
        </div>
      </div>
    </div>

    <div>
      <div class="d-flex justify-space-between table-head">
        <div
            v-for="(item, i) in tableHeader"
            :key="i"
            :style="{ width: item.width }"
        >
          {{ item.name }}
        </div>
      </div>

      <div class="list-layout">
        <div
          v-for="(item, i) in requirementForms"
          :key="i"
        >
          <!-- v-if="item.status !== 'Submitted'" -->
          <RowCard
              :key="i"
              :theme=" item.doc_status === 'Submitted' ? '3' : '2' "
          >
          <v-btn
            small
            icon
            @click="onEdit(item.id)"
            v-bind:style="{ visibility: item.doc_status === 'Submitted' ? 'hidden' : '' }"
          >
              <Iconify icon="material-symbols:edit" size="15px"></Iconify>
            </v-btn>
            <v-btn small icon @click="goToRequirementPreview(item.id)">
              <Iconify icon="carbon:view-filled" size="15px"></Iconify>
            </v-btn>
            <v-btn small icon @click="onDelete(item.id)">
              <Iconify
                  style="color: #b1b1b1"
                  icon="basil:trash-alt-solid"
                  size="15px"
              ></Iconify>
            </v-btn>
            <div :style="{ width: tableHeader[1].width }">{{ item.no }}</div>
            <div :style="{ width: tableHeader[2].width }">{{ item.year }}</div>
            <div :style="{ width: tableHeader[3].width }">
              {{ item.doc_no }}
            </div>
            <div :style="{ width: tableHeader[4].width }">
              เเบบฟอร์มขอใช้บริการเทคโนโลยีสารสนเทศ
            </div>
            <div :style="{ width: tableHeader[5].width }">
              <div v-if="item.p1_last_name" class="one-line font-type-normal">
                <tooltip-text
                  :text="
                    [item.p1_first_name, item.p1_last_name.slice(0, 1)].join(
                      '.'
                    )
                  "
                />
                <!-- {{
                  [item.p1_first_name, item.p1_last_name.slice(0, 1)].join(".")
                }} -->
              </div>
              <div v-else>
                <tooltip-text :text="item.p1_first_name" />
                <!-- {{ item.p1_first_name }} -->
              </div>
            </div>
            <div
              :style="{ width: tableHeader[6].width }"
              :class="
                item.doc_status === 'Submitted' ? 'txt__green' : 'txt__black'
              "
            >
              {{ item.doc_status }}
            </div>
          </RowCard>
        </div>

        <v-pagination
          class="mt-6"
          v-model="paginate.current_page"
          :length="paginate.last_page"
          color="#DE7033"
          @input="getAllForms"
        ></v-pagination>

      </div>
    </div>
  </div>
</template>

<script>
import TextField from "../../components/input/TextField";
import SelectBox from "../../components/input/SelectBox";
import Button from "../../components/input/Button";
import RowCard from "../../components/RowCard";
import services from "../../services";
import {mapState} from "vuex";

export default {
  name: "RequirementList",
  components: {
    TextField,
    SelectBox,
    Button,
    RowCard,
  },
  data() {
    return {
      tableHeader: [
        {
          name: "",
          width: "6%",
        },
        {
          name: "ลำดับ",
          width: "6%",
        },
        {
          name: "ปี งปม.",
          width: "8%",
        },
        {
          name: "เลขที่",
          width: "8%",
        },
        {
          name: "เเบบฟอร์ม",
          width: "46%",
        },
        {
          name: "ผู้นำเข้าข้อมูล",
          width: "13%",
        },
        {
          name: "สถานะ",
          width: "13%",
        },
      ],
      searchData: {
        status: null,
        keyword: null
      },
      statusMaster: [
          'Draft',
          'Submitted',
      ],
      requirementForms: [
        // {
        //   year: '2565',
        //   no: '2565',
        //   form: 'test form',
        //   importBy: 'non',
        //   status: 'แบบร่าง'
        // },
        // {
        //   year: '2565',
        //   no: '2565',
        //   form: 'test form',
        //   importBy: 'non',
        //   status: 'แบบร่าง'
        // },
        // {
        //   year: '2565',
        //   no: '2565',
        //   form: 'test form',
        //   importBy: 'non',
        //   status: 'แบบร่าง'
        // },
      ],
      paginate: {
        total: 1,
        per_page: 1,
        current_page: 1,
        last_page: 1,
      },
    };
  },
  created() {
    if(this.isOIC)
      this.searchData.status = "Submitted";

    this.getAllForms();
  },
  computed: {
    ...mapState({
      isRSP: (state) => state.Auth.User.user_type === "RSP",
      isUSP: (state) => state.Auth.User.user_type === "USP",
      isOIC: (state) => state.Auth.User.user_type === "สป.อว.",
    }),
  },
  methods: {
    async getAllForms(page) {     
      let payload = {
        page: page,
        // per_page: 1,
        status: this.searchData.status ?? this.statusMaster.join(','),
        keyword: this.searchData.keyword
      };
      console.info(payload)

      let res = await this.$apiFire("Requirement/getRequirementForms",payload);
      console.info(res);
      if (res) {
        this.requirementForms = res.data.map((item, index) => {
        return {
          ...item,
          no: (res.current_page - 1) * res.per_page + index + 1
        }
      });
        this.paginate = {
          total: res.total,
          per_page: res.per_page,
          current_page: res.current_page,
          last_page: res.last_page,
        };
      }
    },
    createForm() {
      this.$router.push({name: "RequirementForm"});
    },
    goToRequirementPreview(id) {
      this.$router.push({path: `/requirement-preview/${id}?preview=true`});
    },
    onEdit(id) {
      this.$router.push({path: `/requirement-form/${id}`});
    },
    onDelete(id) {
      console.log(id)
      // sweetalert confirm
      this.$store.commit("General/setModal", {
        theme: "delete",
        title: "ลบข้อมูล ?",
        text: "ท่านยืนยันที่จะลบข้อมูลหรือไม่?",
        buttonText: "ยืนยัน",
        cancelText: "ยกเลิก",
        action: async () => {
          let res = await this.$apiFire("CForm/deleteFormCList",id);
          if (res) {
            this.requirementForms = this.requirementForms.filter(item => item.id != id);
            this.$store.commit("General/setModal", {
              title: "เสร็จสิ้น!",
              theme: "success",
              text: res,
              showCancel: false,
            });
          }
        },
      });

      // this.$swal({
      //   title: "Do you want to delete this?",
      //   showCancelButton: true,
      //   confirmButtonText: "Yes",
      //   confirmButtonColor: "#FD0C0C",
      // }).then(async (result) => {
      //   if (result.isConfirmed) {
      //     // const res = await services.Requirement.deleteRequirementForm(id);
      //     let res = await this.$apiFire("Requirement/deleteRequirementForm",id);

      //     console.log(res);
      //     if (res.status == 200) {
      //       // this.getAllForms(1);
      //       this.requirementForms = this.requirementForms.filter(item => item.id != id);
      //     }
      //   }
      // });
    },

  },
};
</script>

<style scoped lang="scss">
.table-head {
  padding: 0 33px 0 36px;
  margin-bottom: 12px;
  gap: 8px;
}

.list-layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.txt__black {
  color: var(--theme-color-two);
}
.txt__green {
  color: var(--theme-color-three);
}
</style>
